/// <amd-module name="VSS/Redux/Modules/Navigation/NavigationReducer" />
import produce from "immer";
import { NavigationActionTypes, NavigationActions } from "./NavigationActions";
import { INavigationState } from "./NavigationContracts";

export function navigationReducer(state: INavigationState, action: NavigationActions) {
    return produce(state || defaultState, (draft) => {
        switch (action.type) {
            case NavigationActionTypes.FPSNavigateToUrl: {
                draft.isNavigating = true;
                break;
            }
        }
    });
}


export const defaultState: INavigationState = {
    isNavigating: false
}
